export class CherryPair {
  constructor() { this.reset(); }

  grab(side) {
    this.held = side;
    this.origin = this.offset(side);
    this.target = [...this.origin];
    this.velocity[side === -1 ? 0 : 1].fill(0);
  }

  // Delta is measured from the local pointer position at grab time.
  move(delta) {
    if (this.held === null || !delta.every(Number.isFinite)) return;
    this.target = this.origin.map((value, axis) => value + delta[axis]);
    this.target[0] = this.held * Math.max(0, this.target[0] * this.held);
    const distance = Math.hypot(...this.target);
    if (distance > 0.8) this.target = this.target.map(value => value * (0.8 / distance));
  }

  release() { this.held = null; }

  reset() {
    this.positions = [[0, 0, 0], [0, 0, 0]];
    this.velocity = [[0, 0, 0], [0, 0, 0]];
    this.held = null;
    this.origin = [0, 0, 0];
    this.target = [0, 0, 0];
    this.activity = 0;
    this.attached = true;
  }

  step(dt) {
    if (!Number.isFinite(dt) || dt <= 0) return;
    // The exact damped solution stays stable after background-tab pauses.
    const elapsed = Math.min(dt, 2);
    let activity = 0;
    for (let index = 0; index < 2; index++) {
      const side = index === 0 ? -1 : 1;
      const held = side === this.held;
      const target = held ? this.target : [0, 0, 0];
      const omega = held ? 30 : 12;
      const decay = Math.exp(-omega * elapsed);
      const position = this.positions[index], velocity = this.velocity[index];
      for (let axis = 0; axis < 3; axis++) {
        const displacement = position[axis] - target[axis];
        const accelerationTerm = velocity[axis] + omega * displacement;
        position[axis] = target[axis] + (displacement + accelerationTerm * elapsed) * decay;
        velocity[axis] = (velocity[axis] - omega * accelerationTerm * elapsed) * decay;
      }
      // Each fruit stays on its own side of the joining surface.
      if (position[0] * side < 0) { position[0] = 0; velocity[0] = 0; }
      const distance = Math.hypot(...position);
      if (distance > 0.8) {
        for (let axis = 0; axis < 3; axis++) position[axis] *= 0.8 / distance;
        velocity.fill(0);
      }
      if (!held && Math.hypot(...position) < 0.012 && Math.hypot(...velocity) < 0.12) {
        position.fill(0);
        velocity.fill(0);
      }
      activity = Math.max(activity, Math.hypot(...position), Math.hypot(...velocity));
    }
    const separation = Math.hypot(...this.positions[1].map((value, axis) => value - this.positions[0][axis]));
    this.attached = separation < 0.06;
    this.activity = activity;
  }

  deform(point, side, jointWeight=0) {
    const weight=side===0?1:Math.max(0,Math.min(1,jointWeight));
    const offset=this.positions[side===-1?0:1];
    for(let axis=0;axis<3;axis++){
      const shared=(this.positions[0][axis]+this.positions[1][axis])*.5;
      point[axis]+=offset[axis]*(1-weight)+shared*weight;
    }
    return point;
  }

  offset(side) { return [...this.positions[side === -1 ? 0 : 1]]; }
}
